// extracted by mini-css-extract-plugin
export var rateTable = "_53-0";